import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from './RegisterPage.module.css'; 
import AgreementPanel from "./panel/register/AgreementPanel";
import EmailVerificationPanel from "./panel/register/EmailVerificationPanel";
import PasswordSetupPanel from "./panel/register/PasswordSetupPanel";
import SignupSuccessPanel from "./panel/register/SignupSuccessPanel";
import NoLinkedAccountPanel from "./panel/register/NoLinkedAccountPanel";
import LinkAccountPanel from "./panel/register/LinkAccountPanel";
import LinkAccountLoginPanel from "./panel/register/LinkAccountLoginPanel";
import LinkAccountCompletePanel from "./panel/register/LinkAccountCompletePanel";
// import { DialogEnum, showDialog } from '../../utils/dialog/Dialog';
import axios from "../../utils/api/axios";
import { IAM_PATH } from "../../utils/Config";
import { InnocodeButton, useDialog } from "@intsoft/innocode-core";

function RegisterPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const inviteState = location.state; // 소셜 로그인 데이터가 여기에 포함됨
  const { showDialog } = useDialog();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  // 팝업 창 핸들러 상태
  const [popup, setPopup] = useState(null);

  // 소셜 로그인으로 접근했는지 확인
  const isSocialSignup = !!inviteState?.socialData;

  // 테넌트 초대 접근 확인
  const isInvite = !!inviteState?.inviter;

  const [step, setStep] = useState(isSocialSignup ? 7 : 1);
  const [stepHistory, setStepHistory] = useState([isSocialSignup ? 7 : 1]);

  const [userData, setUserData] = useState({
    agreements: {},
    email: '',
    emailVerified: false,
    password: '',
  });

  const [inviteData, setInviteData] = useState({
      email: '', 
      tenantId: '', 
      inviter: '', 
  });

  let unifiedProfile = {
    unifiedProfileId:'a01040314603@gmail.com'
  };
	let unifiedId = {};

 
  // 소셜 로그인으로 넘어온 경우, userData에 소셜 데이터 저장
  useEffect(() => {
    if (isSocialSignup) {
      setUserData(prev => ({
        ...prev,
        socialData: inviteState.socialData,
        sigupType: inviteState.sigupType
      }));
    }

    if(isInvite){
      setUserData(prev => ({
        ...prev,
        email: inviteState.email,
        emailVerified: true
      }));

      setInviteData(prev => ({
        ...prev,
        email: inviteState.email, 
        tenantId: inviteState.tenantId,
        inviter: inviteState.inviter
      }));
    }

  }, [isSocialSignup, inviteState]);

  // 약관 동의 상태 업데이트
  const handleAgreementChange = (agreements) => {
    setUserData(prev => ({
      ...prev,
      agreements,
    }));
  };

  // 이메일 정보 업데이트
  const handleEmailChange = (emailData) => {
    setUserData(prev => ({
      ...prev,
      email: emailData.email,
      emailVerified: emailData.isVerified,
    }));
  };

  // 비밀번호 정보 업데이트 및 회원가입 최종 호출
  const handlePasswordChange = async (password) => {
    setUserData(prev => ({
      ...prev,
      password,
    }));

    submitSignup(password);
  };

  const submitSignup = async (password) => {
    unifiedProfile = {
        unifiedProfileId: userData.email,
        password: password,
        emailVerified: userData.emailVerified,
        termsAgreement: userData.agreements.term,
        privacyAgreement: userData.agreements.privacy,
    };

    const now = new Date().toISOString().slice(0, 10);
    unifiedId = {
        authInfo: {
            [now]: {
                email: [{
                    value: userData.email,
                    verification_status: "verified"
                }]
            }
        }
    };

    if ( userData.sigupType === "social") {
      unifiedProfile.linkedAcounts = {
        [userData.socialData.provider]: {
          provider: userData.socialData.provider,
          oauth_id: userData.socialData.auth_id,
          email: userData.socialData.email,
          connected_at: new Date().toISOString()
        }
      };
    }

    try {
      const payload = {
				"unifiedId": unifiedId,
				"unifiedProfile": unifiedProfile
			};

      const res = await axios.post(`${IAM_PATH}/regist`, payload);

      if (res.data.code === 200) {
          if (userData.sigupType === "social") {
            pushStep(6);
          }else{
            pushStep(4);
          }
          // navigate("/login"); // 회원가입 성공 후 로그인 페이지로 이동
      } else {
        showDialog({
          iconType: "warning",
          type: 'error',
          title: "오류",
          message: "회원가입에 실패했습니다.",
        });
      }
    } catch (err) {
        console.error(err);
        showDialog({
          iconType: "warning",
          type: 'error',
          title: "오류",
          message: "회원가입 중 문제가 발생했습니다.",
        });
    }
  }

  const handleSocialLogin = (provider) => {
      if (popup && !popup.closed) {
          popup.focus();
          return;
      }

      let socialUrl;

      if (provider === 'apple') {
          // Apple 인증 페이지 URL 생성
          const appleAuthConfig = {
              client_id: 'kr.intsoft.zentry', // Apple Developer에서 발급받은 Services ID
              redirect_uri: 'https://iam.innocode.co/oauth/apple/callback', // 백엔드의 /oauth/apple/callback 주소
              response_type: 'code', // code를 받기 위함
              scope: 'name email', // 이름과 이메일 요청
              response_mode: 'form_post', // 백엔드 콜백으로 POST 요청을 보내도록 설정
              state: 'STATE_STRING' // CSRF 방지를 위한 임의의 문자열
          };
          const appleAuthQueryString = new URLSearchParams(appleAuthConfig).toString();
          socialUrl = `https://appleid.apple.com/auth/authorize?${appleAuthQueryString}`;
      } else if (provider === 'spotify') {
            const spotifyAuthConfig = {
                client_id: '32b85776edaf48c1be1ed45305218bdc', 
                response_type: 'code',
                redirect_uri: 'https://iam.innocode.co/oauth/spotify/callback', 
                scope: 'user-read-private user-read-email', 
                state: 'STATE_STRING' // CSRF 방지를 위한 임의의 문자열
            };
            const spotifyAuthQueryString = new URLSearchParams(spotifyAuthConfig).toString();
            socialUrl = `https://accounts.spotify.com/authorize?${spotifyAuthQueryString}`;
      } else if (provider === 'twitter') {
            socialUrl = `https://iam.innocode.co/oauth/twitter/login`;
      } else {
          // 기존 Google, Naver, Kakao 처리 방식
          socialUrl = `https://iam.innocode.co/oauth2/authorization/${provider}`;
      }

      const width = 500;
      const height = 600;
      const currentLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const currentTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
      const currentWidth = window.innerWidth;
      const currentHeight = window.innerHeight;

      const popLeft = currentLeft + (currentWidth / 2) - (width / 2);
      const popTop = currentTop + (currentHeight / 2) - (height / 2);
      const features = `width=${width},height=${height},left=${popLeft},top=${popTop}`;
      const newPopup = window.open(socialUrl, `${provider}_oauth_popup`, features);

      if (!newPopup) {
          showDialog({
            iconType: "warning",
            type: 'error',
            title: "오류",
            message: "팝업이 차단되었습니다. 브라우저 설정을 확인해주세요.",
          });
          return;
      }

      setPopup(newPopup);

      const messageHandler = async (event) => {
        console.log("messageHandler called");
          if (event.origin !== 'https://iam.innocode.co') { // Origin 검사
              return;
          }
          const data = event.data;
          if (data.type === "social_login") {
            setUserData(prev => ({
              ...prev,
              socialData: data,
              sigupType: 'social',
            }));

        		let auth_id = data.auth_id;
            let provider = data.provider;

            const existUrl = `${IAM_PATH}/exist/linkedacounts`;
            const existData = {
                linkedAcounts: {
                    [provider]: {
                        oauth_id: auth_id,
                    }
                }
            };

            const existRes = await axios.post(existUrl, existData);

            if (existRes.data.data) {
              // 연동된 계정이 있다면 바로 로그인
              if(!isPopupOpen){
                setIsPopupOpen(true);
                showDialog({
                  iconType: "warning",
                  type: 'error',
                  title: "오류",
                  message: "이미 계정에 연동 된 계정입니다.",
                });
                setIsPopupOpen(false);
                return;
              }
            } else {
              // 연동된 계정이 없다면 회원가입 페이지로 이동
              const payload = {
                "unifiedProfileId":unifiedProfile.unifiedProfileId,
                "linkedAcounts": {
                  [provider] : {
                    "provider": provider,
                    "oauth_id": auth_id,
                    "email": unifiedProfile.unifiedProfileId,
                    "connected_at": new Date().toISOString()
                  }
                }
              };

              const res = await axios.post(`${IAM_PATH}/update/linkedacounts`, payload);
              pushStep(6);
            }
            window.removeEventListener("message", messageHandler);
          }
      };
      window.addEventListener("message", messageHandler);
  };

  // step 이동 함수
  const pushStep = (newStep) => {
    setStep(newStep);
    setStepHistory(prev => [...prev, newStep]);
  };

  // 뒤로가기 버튼 로직
  const goBack = () => {
    if (stepHistory.length > 1) {
      const newHistory = [...stepHistory];
      newHistory.pop();
      setStepHistory(newHistory);
      setStep(newHistory[newHistory.length - 1]);
    } else {
      navigate('/login');
    }
  };

  // 헤더 뒤로가기 버튼 렌더링 조건
  const shouldShowBackButton = (
    step === 1 || step === 2 || step === 3 || step === 7 || step === 8
  );

  const renderStep = () => {
    switch (step) {  
      case 1:
        return (
          <AgreementPanel
            onNext={() => isInvite ? pushStep(3) : pushStep(2)} 
            onAgreementChange={handleAgreementChange} 
          />
        );
      case 2:
        return (
          <EmailVerificationPanel 
            onNext={() => pushStep(3)} 
            onEmailChange={handleEmailChange} 
          />
        );
      case 3:
        return (
          <PasswordSetupPanel 
            onNext={(pw) => handlePasswordChange(pw)}
          />
        );
      case 4:
        return (
          <SignupSuccessPanel
            onSkip={() => {
              showDialog({
                  iconType: "info",
                  type: 'info',
                  title: "알림",
                  message: "로그인 페이지로 이동합니다.",
                  confirmText: "예",
                  cancelText: "아니요",
                  onConfirm: () => {
                      if(isInvite){
                        navigate("/login", { state: { email:inviteData.email, tenantId:inviteData.tenantId, inviter:inviteData.inviter } });
                      }else{
                        navigate("/login");
                      }
                  },
              });

              // showDialog(DialogEnum.CONFIRM, "건너뛰기", "로그인 페이지로 이동합니다.", () =>{
              //   if(isInvite){
              //     navigate("/login", { state: { email:inviteData.email, tenantId:inviteData.tenantId, inviter:inviteData.inviter } });
              //   }else{
              //     navigate("/login");
              //   }
              // } );
            }}
            onEasyLogin={() => {
              showDialog({
                iconType: "info",
                type: 'info',
                title: "간편로그인 연동",
                message: "간편로그인 연동 페이지로 이동합니다.",
                confirmText: "예",
                cancelText: "아니요",
                onConfirm: () => { 
                  pushStep(5);
                },
            });
              // showDialog(DialogEnum.CONFIRM, "간편로그인 연동", "간편로그인 연동 페이지로 이동합니다.", () => pushStep(5));
            }}
          />
        );
      case 5: // 간편 로그인 연동
        return <LinkAccountPanel onSocialLogin={handleSocialLogin} />;
      case 6: // 간편 로그인 연동 완료
        return <LinkAccountCompletePanel onComplete={() => navigate("/login")} provider={userData.socialData.provider}/>;
      case 7: // 간편 로그인 미 연동
        return (
          <NoLinkedAccountPanel
            onSignup={() => pushStep(1)}
            onLinkAccount={() => pushStep(8)}
          />
        );
      case 8: // 간편로그인 기존 계정 연동 로그인
        return (
          <LinkAccountLoginPanel 
            socialData={userData.socialData}
            onLinkSuccess={() => pushStep(6)}
            onSignup={() => pushStep(1)}
          />
        );     
      default:
        return null;
    }
  };

  return (
    <div className="innocode-breakpoint-layout-bg">
      <div className="innocode-breakpoint-content">
        <div className={styles.layout_container}> 
          <header className={styles.header} id="main-header">
            {shouldShowBackButton && ( 
              <InnocodeButton enablePadding={false} onClick={goBack} designType={'assistive'} theme={'opacity'} iconOnly={true} icon={
                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m15 19-7-7 7-7" />
                </svg>
            }></InnocodeButton>
            )}
          </header>
          <div className={styles.content_wrapper}>{renderStep()}</div>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
